import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MobyDick3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOBY_DICK3;
}

export default MobyDick3PoiTileEntity;
